import { infoFetchGetCombinatoriaI, makeCombinatoria } from "dtos/combinatoria";
import { ENDPOINTS } from "./endpoints";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";

export const postCombinatoria = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetCombinatoriaI>({
    method: "POST",
    uri: ENDPOINTS.COMBINATORIA,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  return makeCombinatoria(response);
};

export const putCombinatoria = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetCombinatoriaI>({
    method: "PUT",
    uri: ENDPOINTS.COMBINATORIA,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  return makeCombinatoria(response);
};

export const getCombinatorias = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetCombinatoriaI>
  >({
    method: "GET",
    uri: ENDPOINTS.COMBINATORIA,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeCombinatoria(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const getCombinatoriaUnica = async (params: any) => {
  const response = await sendRequest<infoFetchGetCombinatoriaI | undefined>({
    method: "GET",
    uri: ENDPOINTS.COMBINATORIA + "/existe",
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  return response;
};

export const getCombinatoriaById = async (id: any, params?: any) => {
  const response = await sendRequest<infoFetchGetCombinatoriaI | undefined>({
    method: "GET",
    uri: ENDPOINTS.COMBINATORIA + "/" + id,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return response ? makeCombinatoria(response) : undefined;
};

export const deleteCombinatoria = async (id: any) => {
  const response = await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.COMBINATORIA + "/" + id,
  });
  return response;
};
